import { render, staticRenderFns } from "./MediaImport.vue?vue&type=template&id=98498760&scoped=true"
import script from "./MediaImport.vue?vue&type=script&lang=js"
export * from "./MediaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98498760",
  null
  
)

export default component.exports